import { Injectable } from "@angular/core";

import { map, Observable, share } from "rxjs";

import { environment } from "@environments/environment";

import { TenantUtilities } from "@core/utilities";

import { AbstractApiServiceBase } from "./abstract-data.service";


@Injectable({ providedIn: 'root' })
export class TenantDataService extends AbstractApiServiceBase {

  public getIsValidTenant(): Observable<boolean> {
    const baseUrl: string = `${environment.authUrl}/v1/tenants/valid?tenantName=${TenantUtilities.getTenantFromRoute()}`;

    return this.http.get<boolean>(baseUrl).pipe(share(), map(items => items));
  }
}
